export default {
    title: 'Profilo',
    subtitle: 'Gestisci le tue informazioni personali e preferenze',
    tabs: {
        preferences: 'Preferenze',
        account: 'Account',
        password: 'Password',
        picture: 'Foto Profilo',
        companies: 'Aziende',
        team: 'Team',
        integrations: 'Integrazioni',
    },
    preferences: {
        language: {
            title: 'Lingua',
            description: 'Seleziona la tua lingua preferita per l\'interfaccia',
        },
        theme: {
            title: 'Tema',
            description: 'Scegli tra tema chiaro e scuro',
        },
    },
    account: {
        title: 'Informazioni Account',
        description: 'Aggiorna le tue informazioni personali',
        legalSection: {
            title: 'Legale',
            description: 'Consulta i nostri Termini e condizioni e la Privacy Policy.',
        },
        firstName: 'Nome',
        firstNamePlaceholder: 'Inserisci il tuo nome',
        lastName: 'Cognome',
        lastNamePlaceholder: 'Inserisci il tuo cognome',
        email: 'Email',
        emailPlaceholder: 'Inserisci il tuo indirizzo email',
        phone: 'Telefono',
        phonePlaceholder: 'Inserisci il tuo numero di telefono',
        jobTitle: 'Ruolo',
        jobTitlePlaceholder: 'Inserisci il tuo ruolo',
        department: 'Dipartimento',
        departmentPlaceholder: 'Inserisci il tuo dipartimento',
    },
    password: {
        title: 'Cambia Password',
        description: 'Aggiorna la password del tuo account',
        currentPassword: 'Password Corrente',
        currentPasswordPlaceholder: 'Inserisci la tua password corrente',
        newPassword: 'Nuova Password',
        newPasswordPlaceholder: 'Inserisci la tua nuova password',
        confirmPassword: 'Conferma Password',
        confirmPasswordPlaceholder: 'Conferma la tua nuova password',
        mismatch: 'Le password non corrispondono',
        changePassword: 'Cambia Password',
    },
    picture: {
        title: 'Foto Profilo',
        description: 'Carica e gestisci la tua foto profilo',
        global: 'Globale (Tutte le Aziende)',
        scope: 'Ambito',
        scopeDescription: 'Scegli se questa immagine deve essere visibile globalmente o solo per un\'azienda specifica',
        selectFile: 'Seleziona File',
        upload: 'Carica',
        invalidFileType: 'Tipo di file non valido. Seleziona un\'immagine PNG, JPG, JPEG o WEBP.',
        fileTooLarge: 'La dimensione del file supera il limite di 5MB.',
    },
    companies: {
        title: 'Aziende',
        description: 'Visualizza tutte le aziende di cui fai parte',
        noCompanies: 'Non fai parte di nessuna azienda',
        primary: 'Principale',
        noType: 'Nessun Tipo',
        types: {
            sender: 'Mittente',
            receiver: 'Destinatario',
            freight_forwarder: 'Spedizioniere',
            port_authority: 'Autorità Portuale',
            carrier: 'Vettore',
            customs_broker: 'Spedizioniere Doganale',
            insurance_provider: 'Fornitore di Assicurazioni',
        },
        role: {
            super_admin: 'Super Admin',
            company_admin: 'Admin Azienda',
            operator: 'Operatore',
            viewer: 'Visualizzatore',
        },
        editDetails: 'Dettaglio azienda',
    },
    companyEdit: {
        nav: {
            companyInfo: 'Dati azienda',
            hsCodes: 'Codici HS',
            routes: 'Rotte',
            carriers: 'Carrier',
            ariaLabel: 'Sezioni profilo aziendale',
        },
        title: 'Profilo aziendale',
        back: 'Torna alle aziende',
        save: 'Salva modifiche',
        saved: 'Profilo aziendale salvato',
        saveError: 'Impossibile salvare il profilo aziendale',
        loadError: 'Impossibile caricare i dati dell\'azienda',
        notMember: 'Non fai parte di questa azienda',
        readOnlyHint:
            'Solo gli amministratori aziendali possono modificare questi dati. Contatta un admin se serve un aggiornamento.',
        retry: 'Riprova',
        operationalProfile: {
            title: 'Profilo operativo',
            description:
                'Indica i principali codici HS, le rotte e i carrier che usi di più. Completa la checklist del Control Hub e arricchisce il contesto per Ask Eve.',
            hsHeading: 'Prodotti (codici HS)',
            hsLabel: 'Codice HS',
            hsSearchLabel: 'Cerca codici HS',
            hsSearchPlaceholder: 'Parole chiave o cifre (es. avocado, 0804)',
            hsPlaceholder: 'es. 080440',
            hsInvalid: 'Inserisci un codice HS valido (cifre e punti, min. 4 caratteri).',
            add: 'Aggiungi',
            hsEmpty: 'Nessun codice HS aggiunto.',
            hsAlreadyDeclared: 'Questo codice HS è già nell\'elenco.',
            hsAddCodesButton: 'Aggiungi codici HS',
            hsTableFilterHint:
                'Filtra la tabella qui sotto — per aggiungere nuovi codici usa il pulsante sopra.',
            removeHs: 'Rimuovi {{code}}',
            routesHeading: 'Rotte principali',
            addRoute: 'Aggiungi rotta',
            routesEmpty: 'Nessuna rotta aggiunta.',
            routesIncomplete: 'Completa ogni rotta (porto origine e destinazione) oppure rimuovi le righe incomplete.',
            legacyRouteHint: 'Salvata come paesi: {{origin}} → {{dest}}. Seleziona i porti sotto per aggiornare.',
            origin: 'Paese di origine',
            destination: 'Paese di destinazione',
            originPort: 'Porto di origine',
            destinationPort: 'Porto di destinazione',
            portSearchPlaceholder: 'Cerca nome porto o UN/LOCODE',
            routeNote: 'Nota (opzionale)',
            removeRoute: 'Rimuovi rotta',
            carriersHeading: 'Carrier più usati',
            carrierSelectLabel: 'Aggiungi carrier',
            carrierSearchLabel: 'Cerca carrier',
            carrierSearchPlaceholder: 'Nome o SCAC',
            carrierPlaceholder: 'Seleziona un carrier',
            addCarrier: 'Aggiungi carrier',
            carriersEmpty: 'Nessun carrier aggiunto.',
            carriersAddButton: 'Aggiungi carrier',
            carriersTableFilterHint:
                'Filtra la tabella qui sotto — per aggiungere carrier usa il pulsante sopra.',
            carrierAlreadyDeclared: 'Questo carrier è già nell\'elenco.',
            carrierModalTitle: 'Aggiungi carrier',
            carrierModalDescription:
                'Cerca e seleziona uno o più carrier oceanici. Verranno aggiunti alla conferma.',
            carrierModalStagingEmpty: 'Nessun carrier selezionato — cerca sopra per aggiungerne.',
            carrierModalCancel: 'Annulla',
            carrierModalConfirm: 'Aggiungi all\'elenco',
            removeCarrier: 'Rimuovi {{scac}}',
            hsTableSearchPlaceholder: 'Cerca in elenco…',
            hsTableTitle: 'Codici HS dichiarati',
            hsCodeColumn: 'Codice',
            hsDescriptionColumn: 'Descrizione',
            tableActions: 'Azioni',
            routesTableSearchPlaceholder: 'Cerca rotte…',
            routesTableTitle: 'Rotte',
            routesTableHint: 'Espandi una riga per modificare gli arrangement document e caricare PDF.',
            carriersTableSearchPlaceholder: 'Cerca carrier…',
            carriersTableTitle: 'Carrier',
            hsModalTitle: 'Aggiungi codici HS',
            hsModalDescription:
                'Cerca e seleziona uno o più codici. Verranno aggiunti alla conferma.',
            hsModalStagingEmpty: 'Nessun codice selezionato — cerca sopra per aggiungerne.',
            hsModalCancel: 'Annulla',
            hsModalConfirm: 'Aggiungi all\'elenco',
            carrierColumnScac: 'SCAC',
            carrierColumnName: 'Nome',
            carrierColumnCountry: 'Paese',
            saveOperational: 'Salva profilo operativo',
            saved: 'Profilo operativo salvato',
            saveError: 'Impossibile salvare il profilo operativo',
            loadError: 'Impossibile caricare il profilo operativo',
        },
    },
    integrations: {
        title: 'Integrazioni Email',
        description: 'Collega i tuoi account Gmail o Outlook personali a Eve Mind',
        connectedAccounts: 'Account Collegati',
        connectNew: 'Collega Nuovo Account',
        connectGmail: 'Collega Gmail',
        connectOutlook: 'Collega Outlook',
        confirmDisconnect: 'Sei sicuro di voler disconnettere questo account email?',
        providers: {
            gmail: 'Gmail',
            outlook: 'Outlook',
        },
        status: {
            active: 'Attivo',
            inactive: 'Inattivo',
            error: 'Errore',
            authentication_required: 'Autenticazione Richiesta',
        },
        tracking: {
            title: 'Tracking Container',
            description: 'Configura gli aggiornamenti automatici del tracking per le tue spedizioni',
            autoRefresh: 'Aggiornamenti Automatici',
            autoRefreshDescription: 'Abilita gli aggiornamenti automatici dello stato del tracking',
            dailyUpdates: 'Aggiornamenti Giornalieri',
            dailyUpdatesDescription: 'Numero di aggiornamenti tracking al giorno',
            updateTime: 'Orario Aggiornamento (UTC)',
            updateTimeDescription: 'Orario in cui viene eseguito l\'aggiornamento giornaliero del tracking',
            saveSuccess: 'Impostazioni tracking salvate con successo',
            saveError: 'Impossibile salvare le impostazioni tracking',
            loadError: 'Impossibile caricare le impostazioni tracking',
        },
    },
};

